import styled from 'styled-components';
import {commonPalette} from 'styles/palette';
import {svgElementsFillCurrentColor} from 'styles/helpers';

export const ToolbarItem = styled.div`
  border-left: 1px solid #ededed;
  height: 100%;
  position: relative;
  &:first-child {
    border-left: none;
  }
  border-top: 1px solid;
  border-top-color: ${p => (p.isActive ? '#ffffff' : '#ededed')};
`;

export const IconAndTextWrapper = styled.div.attrs({className: 'iconWrapper'})`
  position: relative;
  > label {
    display: block;
    line-height: 1.125rem;
    padding: 4px 0.5rem 0;
    max-width: 100%;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    cursor: inherit;
    font-size: 0.675rem;
  }

  .inline-hint-svg {
    width: 15px;
    max-height: 15px;
    height: auto;
    margin: 0 auto;

    svg {
      height: 100%;
      width: 100%;
      display: block;
      fill: currentColor !important;

      ${svgElementsFillCurrentColor}
    }
  }
`;

export const ItemButton = styled.button`
  height: 100%;
  width: 100%;
  background: none;
  border: none;
  outline: none;
  padding: 0;

  &:disabled {
    .iconWrapper {
      opacity: 0.1;
    }
  }

  &:not(:disabled) {
    color: ${p => (p.isWarning ? commonPalette.orange : p.theme.hintColor)};
    opacity: 1;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
      .iconWrapper {
        opacity: 1;
      }
    }
  }

  &.active {
    color: ${p => (p.isWarning ? commonPalette.orange : p.theme.mainDarker)};
    opacity: 1;
    .iconWrapper {
      opacity: 1 !important;
    }
    &:hover {
      color: ${p => (p.isWarning ? commonPalette.orange : p.theme.mainDarker)};
      background: none;
    }
  }
`;
